import cookieStorage from './cookieStorage';

// Wires the close button of the shared cookie-consent banner (markup +
// server-side gate live in `_core/.../partials/_cookie-banner.phtml`). Lives in
// a bundle (loaded via the header island on every brand page) rather than an
// inline <script>, which brand CSP can block. Persists dismissal through the
// shared `cookieStorage` helper — the PHP gate reads the same `coockie__banner`
// cookie and renders nothing on the next load.
const COOKIE_NAME = 'coockie__banner';

export default function initCookieBanner() {
    const banner = document.querySelector('.cookie-policy');
    if (!banner) return;

    const btn = banner.querySelector('.cookie__close');
    if (!btn) return;

    btn.addEventListener('click', () => {
        cookieStorage.set(COOKIE_NAME, 'true', { days: 365 });
        banner.remove();
    });
}
